import { render } from "./Paper.vue?vue&type=template&id=12bef2c8"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"

import "./Paper.vue?vue&type=style&index=0&id=12bef2c8&lang=scss"
script.render = render

export default script